import { createComponent } from '../lib';
import { VmMenuRadio, VmIcon, VmMenuItem } from '@vime/core';
import { define } from '../lib';
define('vm-menu-radio', VmMenuRadio);
define('vm-icon', VmIcon);
define('vm-menu-item', VmMenuItem);
;
export default createComponent('vm-menu-radio', new Set(['label', 'value', 'checked', 'badge', 'checkIcon', 'icons']));
